export default __webpack_public_path__ + "static/media/rider.39b0919d.svg";